<template>
    <div class="content-page">
        <crumbs></crumbs>
        <div class="operate-group">
            <div class="shadow-box tabs-box">
                <el-tabs v-model="menuActive" @tab-click="menuTabClick">
                    <el-tab-pane :label="item.name" :name="item.path" v-for="item in settingMenus" :key="item.path"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="add-btn" v-if="menuActive == '/setting/menuManage'" @click="handleAddItem">
                <img src="~@/assets/image/icon-add-user.svg" alt="" /> 新增菜单
            </div>
            <div class="add-btn" v-else-if="menuActive == '/setting/userManage'" @click="handleAddItem">
                <img src="~@/assets/image/icon-add-user.svg" alt="" /> 新增用户
            </div>
            <div class="add-btn" v-else-if="menuActive == '/setting/productManage'" @click="handleAddItem">
                <img src="~@/assets/image/icon-add-user.svg" alt="" /> 新增产品
            </div>
        </div>

        <router-view ref="manageRef"></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menuActive: '',
            settingMenus: []
        }
    },
    computed: {
        menuList() {
            return this.$store.getters.getMenuList;
        }
    },
    watch: {
        // 菜单数据异步就绪后，同步tab选中并处理默认跳转
        menuList: {
            handler() {
                this.syncActiveMenu();
            },
            immediate: true
        },
        $route() {
            this.syncActiveMenu();
        }
    },
    methods: {
        // 同步tab选中状态；系统设置下未匹配到子菜单（含redirect到无权限页面）时，默认跳第一个tab
        syncActiveMenu() {
            this.settingMenus = this.menuList.find(x => x.path === '/setting')?.subMenu ?? [];
            if (this.settingMenus.some(x => x.path === this.$route.path)) {
                this.menuActive = this.$route.path;
            } else if (this.settingMenus.length && this.$route.path.startsWith('/setting')) {
                this.menuActive = this.settingMenus[0].path;
                if (this.$route.path !== this.settingMenus[0].path) {
                    this.$router.push(this.settingMenus[0].path);
                }
            }
        },
        // tab切换
        menuTabClick(val) {
            this.$router.push(val.name);
        },
        // 点击新增
        handleAddItem() {
            this.$refs.manageRef.moreOperation('add');
        },
    }
}
</script>

<style lang="scss" scoped>
.content-page {
    width: 80%;
    margin: 0 auto;
    padding-top: $pc-header-height;
    min-height: calc(100vh - #{$pc-header-height});
    padding-bottom: 4rem;
    .operate-group {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        .tabs-box {
            flex: 1;
            padding: 0 1.9rem;
            /deep/ .el-tabs {
                .el-tabs__item {
                    color: #666666;
                    font-size: 16px;
                    font-weight: 550;
                    &:hover,
                    &.is-active {
                        color: $primary-btn-color !important;
                    }
                }
                .el-tabs__header {
                    margin-bottom: 0;
                }
                .el-tabs__nav-wrap::after {
                    height: 0;
                }
            }
        }
        .add-btn {
            background-color: $primary-btn-color;
            width: 7.2rem;
            height: 40px;
            box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
            border-radius: 12px;
            color: #fff;
            @include bothCenter;
            margin-left: 12px;
            cursor: pointer;
            img {
                width: 15px;
                height: 15px;
                filter: brightness(0) invert(1);
                margin-right: 3px;
            }
        }
    }
}
</style>